/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

import axiosInstance from '../axios.config';
import API_ENDPOINTS from '../endpoints';

export const authService = {
  // Login
  login: async (credentials) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
      
      if (response && response.status === 'success' && response.data) {
        const { accessToken, refreshToken, user } = response.data;
        
        // Store tokens
        if (accessToken) {
          localStorage.setItem('accessToken', accessToken);
        }
        if (refreshToken) {
          localStorage.setItem('refreshToken', refreshToken);
        }
        // Store user data
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
        }
        
        // Transform response to match expected format
        return {
          status: 'success',
          data: {
            user,
            tokens: {
              access_token: accessToken,
              refresh_token: refreshToken,
            },
          },
        };
      }
      
      return response;
    } catch (error) {
      console.error('[AuthService] Login error:', error);
      throw error;
    }
  },

  // Register
  register: async (userData) => {
    return await axiosInstance.post(API_ENDPOINTS.AUTH.REGISTER, userData);
  },

  // Logout
  logout: async () => {
    try {
      await axiosInstance.post(API_ENDPOINTS.AUTH.LOGOUT);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
  },

  // Get current user
  getCurrentUser: async () => {
    return await axiosInstance.get(API_ENDPOINTS.AUTH.ME);
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await axiosInstance.post(API_ENDPOINTS.AUTH.REFRESH, {
      refreshToken,
    });
    
    if (response && response.status === 'success' && response.data) {
      const { accessToken, refreshToken: newRefreshToken } = response.data;
      
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
      }
      if (newRefreshToken) {
        localStorage.setItem('refreshToken', newRefreshToken);
      }
    }
    
    return response;
  },
};

export default authService;

